export default __webpack_public_path__ + "static/media/email.1f0c7e51.svg";